/**
 * Reusable "Coming next" panel for hub sections that are Phase-3-deferred.
 *
 * The Build hub's nav silhouette includes six sections we want visible
 * (Voice & greeting, Custom instructions, Capabilities, Integrations,
 * Embed & share, Advanced) but not yet wired. When a visitor clicks
 * those (or in Phase 2 they can't — they're disabled in the nav), they
 * land here: a section header + a single panel explaining what's
 * coming. This sets expectations without faking functionality.
 */

import { Icon } from "./Icon.js";

interface ComingNextProps {
  title: string;
  blurb: string;
  body: string;
  icon?: string;
}

/**
 * Empty-state panel marking a Phase-3 section. `title`/`blurb` populate
 * the section head, `body` is the placeholder copy. `icon` defaults to
 * the lock-style `info` glyph used for "Coming next" treatments
 * elsewhere on the page.
 */
export function ComingNext({
  title,
  blurb,
  body,
  icon = "info",
}: ComingNextProps) {
  return (
    <div>
      <div className="section-head">
        <h2>{title}</h2>
        <p>{blurb}</p>
      </div>
      <div className="panel coming-next" data-testid="coming-next-panel">
        <span className="lock-pill">
          <Icon name="info" size={11} /> Coming next
        </span>
        <div className="cn-ico">
          <Icon name={icon} size={28} color="var(--ink-3)" />
        </div>
        <p>{body}</p>
      </div>
    </div>
  );
}
